import { render, staticRenderFns } from "./ChatCard.vue?vue&type=template&id=1eefd2c2&scoped=true"
import script from "./ChatCard.vue?vue&type=script&lang=js"
export * from "./ChatCard.vue?vue&type=script&lang=js"
import style0 from "./ChatCard.vue?vue&type=style&index=0&id=1eefd2c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eefd2c2",
  null
  
)

export default component.exports